import request from "@/utils/request";

// 用户列表
export const getUserList = (data) => {
  return request({
    url: `/pushup-admin/admin/user/list`,
    method: "post",
    data
  });
};
// 修改角色
export const getUpdataUser = (data) => {
  return request({
    url: `/pushup-admin/admin/user`,
    method: "put",
    data
  });
}
// 修改状态
export const getUpdataStatus = (data) => {
  return request({
    url: `/pushup-admin/admin/user/status`,
    method: "put",
    data
  });
}
// 添加用户
export const getAddUser = (data) => {
  return request({
    url: `/pushup-admin/admin/user`,
    method: "post",
    data
  });
}
// 删除用户http://localhost:10308/3
export const getDeleteUser = (data) => {
  return request({
    url: `/pushup-admin/admin/user/${data}`,
    method: "delete",
  });
}